import eventBus from '@/event'

const SnipCartListener = {
  install (Vue, options) {
    setTimeout(function () {
      Snipcart.events.on('theme.routechanged', (routesChange) => {
        if (routesChange.from === '/' && routesChange.to !== '/') {
          console.log('cart opened')
          // let cart = window.Snipcart.store.getState().cart
          // if (cart.subtotal < 50) {
          //   console.log('tell user to add more variety')
          //   window.swal({
          //     title: 'Want Free Shipping?',
          //     text: 'Order up to $100 worth of SanitizerWristbands NOW. Buy for friends and family Today.',
          //     icon: 'https://cdn2.iconfinder.com/data/icons/shipping-security-1/48/JD-31-512.png'
          //   })
          // }
        }
        if (routesChange.from !== '/' && routesChange.to === '/') {
          window.analytics.track('Closed Cart')
        }
      })
      window.Snipcart.events.on('shipping.selected', (shippingMethod) => {
        console.log(shippingMethod)
        let billingAddress = window.Snipcart.store.getState().cart.billingAddress
        let emailAddress = window.Snipcart.store.getState().cart.email
        let custData = {
          address: billingAddress.address1,
          city: billingAddress.city,
          country: billingAddress.country,
          firstName: billingAddress.fullName.split(' ')[0],
          lastName: billingAddress.fullName.split(' ')[1],
          email: emailAddress
        }
        window.analytics.alias(emailAddress)
        window.analytics.identify(emailAddress, custData)
        window.analytics.track('Selected Shipping Method', shippingMethod)
      })
      window.Snipcart.events.on('customer.registered', (customer) => {
        window.analytics.alias(customer.email)
        window.analytics.identify(customer.email, customer)
        window.analytics.track('Signed Up', {
          userLogin: customer.email,
          type: 'shopper'
        })
      })
      window.Snipcart.events.on('customer.signedin', (customer) => {
        window.analytics.alias(customer.email)
        window.analytics.identify(customer.email, customer)
        window.analytics.track('Signed In', {
          email: customer.email
        })
      })
      window.Snipcart.events.on('cart.confirm.error', (confirmError) => {
        window.analytics.track('Cart Confirmation Error', confirmError)
      })
      window.Snipcart.events.on('payment.failed', (paymentError) => {
        window.analytics.track('Payment Failed', paymentError)
      })

      window.Snipcart.events.on('item.adding', (parsedCartItem) => {
        console.log(parsedCartItem)
        eventBus.$emit('show-subscribe-modal')
      })

      window.Snipcart.events.on('cart.confirmed', (cartConfirmResponse) => {
        window.analytics.track('Completed Order', cartConfirmResponse)
      })
      // check if cart items if bigger than 2 and time on site is less than
      function visitCount () {
        let visits = Number(localStorage.getItem('SWBVisitCount'))
        let current = Boolean(sessionStorage.getItem('SWBSession'))
        let cartAlert = Boolean(sessionStorage.getItem('SWBSessionCart'))

        if (!current) {
          visits++
        }
        let cartItems = window.Snipcart.store.getState().cart.items.items
        localStorage.setItem('SWBVisitCount', visits)
        sessionStorage.setItem('SWBSession', true)

        if (visits > 1 && cartItems.length >= 2 && !cartAlert) {
          // window.swal({
          //   title: 'Forgetting Anything?',
          //   text: `You have ${cartItems.length} SanitizerWristbands in your shopping cart. Get 10% discount when you checkout now. \n\n Discount Code: MEDIUMREADER-10`,
          //   icon: 'info',
          //   button: {
          //     text: 'Proceed to Checkout',
          //     className: 'btn btn-danger'
          //   }
          // })
          //   .then((e) => {
          //     sessionStorage.setItem('SWBSessionCart', true)
          //     window.analytics.track('Clicked Checkout Alert')
          //     let currentUrl = window.location.href
          //     window.location.href = `${currentUrl}#/cart`
          //   })
        }
        return visits
      }
      visitCount()
    }, 3000)
    Vue.mixin({
      data () {
        return {
          listenerCounter: 0
        }
      },
      mounted () {
      }
    })
  }
}

export default SnipCartListener



// WEBPACK FOOTER //
// ./src/mixins/snipCartMixin.js